var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionFollowTrackColored({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11V16.7574C18 17.553 17.6839 18.3161 17.1213 18.8787V18.8787C15.9497 20.0503 14.0503 20.0503 12.8787 18.8787V18.8787C12.3161 18.3161 12 17.553 12 16.7574V7.24267C12 6.44703 11.6839 5.68396 11.1213 5.12135V5.12135C9.94975 3.94978 8.05025 3.94978 6.87868 5.12135V5.12135C6.31607 5.68396 6 6.44703 6 7.24267V13",
    stroke: "#5714CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.00003C16.3431 5.00003 15 6.34318 15 8.00003C15 9.65689 16.3431 11 18 11C19.6569 11 21 9.65689 21 8.00003C21 6.34318 19.6569 5.00003 18 5.00003ZM18 7.00003C18.5523 7.00003 19 7.44775 19 8.00003C19 8.55232 18.5523 9.00003 18 9.00003C17.4477 9.00003 17 8.55232 17 8.00003C17 7.44775 17.4477 7.00003 18 7.00003Z",
    fill: "url(#paint0_linear_2330_8595)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13C4.34315 13 3 14.3432 3 16C3 17.6569 4.34315 19 6 19C7.65685 19 9 17.6569 9 16C9 14.3432 7.65685 13 6 13ZM6 15C6.55228 15 7 15.4478 7 16C7 16.5523 6.55228 17 6 17C5.44772 17 5 16.5523 5 16C5 15.4478 5.44772 15 6 15Z",
    fill: "#727272"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.9996C5.44785 14.9996 5.00022 15.4475 5 15.9996C5 16.5519 5.44771 16.9996 6 16.9996C6.55229 16.9996 7 16.5519 7 15.9996C6.99978 15.4475 6.55215 14.9996 6 14.9996ZM18 6.99963C17.4479 6.99963 17.0002 7.44753 17 7.99963C17 8.55191 17.4477 8.99963 18 8.99963C18.5523 8.99963 19 8.55191 19 7.99963C18.9998 7.44753 18.5521 6.99963 18 6.99963Z",
    fill: "#FFC107"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13184 11.005C6.74043 11.0505 7.28186 11.4108 7.55957 11.9542L7.61523 12.0734L9.85352 17.4005L9.91699 17.5753C9.97179 17.7534 9.99999 17.939 10 18.1261V18.1915C9.99977 19.128 9.28799 19.8977 8.37598 19.9904L8.19043 20.0001C7.98007 20.0001 7.77199 19.963 7.5752 19.8917L7.38184 19.8087L6 19.1173L4.61816 19.8087C4.36696 19.9343 4.08945 20.0001 3.80859 20.0001C2.80984 19.9999 2.00022 19.1903 2 18.1915V18.1671L2.00879 17.9855C2.02664 17.8058 2.07097 17.6293 2.14062 17.462L4.38477 12.0782L4.43945 11.9581C4.73614 11.3737 5.3382 11.0001 6.00098 11.0001L6.13184 11.005Z",
    fill: "#FFC107",
    stroke: "#5714CC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2330_8595",
    x1: 18,
    y1: 11,
    x2: 18,
    y2: 5.00003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5714CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732EEB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionFollowTrackColored);
export default __webpack_public_path__ + "static/media/ic_action_follow_track_colored.5636c54fe18c583621190c254e594479.svg";
export { ForwardRef as ReactComponent };